import { getValue, curry, curryPartner } from './helpers';

export function BreakdownAge() {
  const isIncomeGraph = this.ui.graphType.value === 'income';

  if (isIncomeGraph) {
    return getValue(this, 'inputs.RetirementAge');
  }

  return getValue(this, 'inputs.AgeNow');
}

function fnRetirementAge(modifier) {
  return function RetirementAge() {
    return Math.max(getValue(this, 'inferred.PreservationAge'), getValue(this, `inputs.AgeNow${modifier}`));
  };
}
export const RetirementAge = curry(fnRetirementAge);
export const RetirementAge2 = curryPartner(fnRetirementAge);

function fnAgeNow(modifier) {
  return function AgeNow() {
    return getValue(this, `inputs.AgeNow${modifier}`);
  };
}
export const AgeNow = curry(fnAgeNow);
export const AgeNow2 = curryPartner(fnAgeNow);

function fnAfterRetirementAge(modifier) {
  return function AfterRetirementAge() {
    return getValue(this, `inputs.RetirementAge${modifier}`) + 1;
  };
}
export const AfterRetirementAge = curry(fnAfterRetirementAge);
export const AfterRetirementAge2 = curryPartner(fnAfterRetirementAge);
